<template>
  <div>


    <!-- Vant 2 Dialog 核心组件 -->
    <van-dialog
      v-model="dialogVisible"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >

      <!-- 对话框主体 -->
      <div class="dialog-body">
        <!-- 3个固定气象指标 -->
        <div class="data-grid" v-if="result.location">
          <div class="data-card card-rain">
            <div class="icon-circle">🌧️</div>
            <div class="value" :class="{ dash: result.precipitation === '-' }">
              {{ result.precipitation }}<span class="unit" v-if="result.precipitation !== '-'">mm</span>
            </div>
            <div class="label">年降水量</div>
          </div>
          <div class="data-card card-temp">
            <div class="icon-circle">🌡️</div>
            <div class="value" :class="{ dash: result.temperature === '-' }">
              {{ result.temperature }}<span class="unit" v-if="result.temperature !== '-'">℃</span>
            </div>
            <div class="label">年均温度</div>
          </div>
          <div class="data-card card-sun">
            <div class="icon-circle">☀️</div>
            <div class="value" :class="{ dash: result.climate_type === '-' }">
              {{ result.climate_type }}
            </div>
            <div class="label">气候类型</div>
          </div>
        </div>


        <!-- 地图 -->
      <div class="map-section" v-if="result.location">
        <div class="map-header">
          <span>地图位置</span>
          <van-tag type="success" size="mini">高德</van-tag>
        </div>
        <div class="map-canvas">
          <img :src="result.map_url" style="object-fit:contain;width:100%; "/>
          <div class="map-marker" style="left:50%; top:45%;">
          </div>
          <button class="map-open-btn" v-if="result.map_web_url" @click="openMap">
            在地图打开
          </button>
        </div>
      </div>

        <!-- 地理描述 -->
        <div class="geo-section">
          <div class="geo-title">地理概况</div>
          <div class="geo-text">
            <p class="auto-scroll-p">{{ defaultLocation }}</p>
          </div>
        </div>
      </div>

      <!-- 关闭按钮 -->
      <div class="dialog-footer">
        <van-button type="default" block round @click="close()">
          关闭
        </van-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>


export default {
  name: 'ClimateDialog',
  props: {
    // 默认查询地点（外部传递）
    defaultLocation: {
      type: String,
      default: '杭州西湖'
    },
    mapImg: {
      type: String,
      default: ''
    },
    baseUrl: {
      type: String,
      default: `${process.env.VUE_APP_API_BASE_URL}/api`
    },
  },
  data() {
    return {
      dialogVisible: false,
      result: {}
    }
  },
  watch: {
    // 监听 dialogVisible 第一次变为 true 时加载数据
    dialogVisible(val) {
      if (val) {
        this.loadData()
        this.loaded = true
      }
    }
  },
  computed: {
    // 拆分地理文本为段落
    geoParagraphs() {
      if (!this.result.geo_text) return [];
      return this.result.geo_text.split(/\n+/).filter(p => p.trim());
    },
  },
  methods: {
    async showDialog() {
      this.dialogVisible = true;
    },
    close()
    {
      this.dialogVisible = false
      this.$emit('close')
    },
    // 加载气象数据
    async loadData() {
    this.result = JSON.parse(localStorage.getItem('GEODetails')) || [];
        if(this.result != [] && this.result.climate_type != undefined)
            this.result.climate_type = this.result.climate_type.replace('气候', '')

        if(this.result != [] && this.result.precipitation != undefined)
            this.result.precipitation = this.result.precipitation.replace('毫米', '')

        if(this.result != [] && this.result.temperature != undefined)
            this.result.temperature = this.result.temperature.replace('摄氏度', '')
    },
    // 打开地图链接
    openMap() {
      if (this.result.map_web_url) {
        window.open(this.result.map_web_url, '_blank');
      }
    }
  }
}
</script>

<style scoped>
/* 基础样式（保留原有样式并添加scoped） */
.van-dialog {
  width: 92% !important;
  max-width: 40rem !important;
  top: 49% !important;
}
.van-dialog__content {
  /* max-height: 80vh !important; */
  overflow-y: auto !important;
  padding: 0 !important;
}

.dialog-body { padding: 1rem; }

/* 标题 */
.location-header {
  text-align: center;
  margin-bottom: 1rem;
  padding-top: 1rem;
}
.location-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: bold;
  color: #323233;
}
.location-header .sub {
  font-size: .75rem;
  color: #969799;
  margin-top: .25rem;
}

/* 三列数据卡片 */
.data-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: .625rem;
  margin-bottom: 1rem;
}
.data-card {
  background: #fff;
  border-radius: .75rem;
  padding: 1rem .375rem;
  text-align: center;
  border: .0625rem solid #ebedf0;
}
.data-card .icon-circle {
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto .5rem;
  font-size: 1.25rem;
}
.card-rain .icon-circle { background: #e6f7ff; }
.card-temp .icon-circle { background: #fff2e8; }
.card-sun .icon-circle { background: #f6ffed; }

.data-card .value {
  font-size: 1.125rem;
  font-weight: bold;
  color: #323233;
  margin-bottom: .25rem;
}
.data-card .value.dash {
  color: #c8c9cc;
  font-size: 1.375rem;
}
.data-card .label {
  font-size: .6875rem;
  color: #969799;
}
.data-card .unit {
  font-size: .6875rem;
  color: #969799;
}

/* CSS模拟地图 */
.map-section {
  margin-bottom: 1rem;
  border-radius: .75rem;
  overflow: hidden;
  background: #fff;
  border: .0625rem solid #ebedf0;
}
.map-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: .625rem .75rem;
  background: #fafafa;
  border-bottom: .0625rem solid #ebedf0;
  font-size: .8125rem;
  color: #646566;
}
.map-canvas {
  position: relative;
  width: 100%;
  background: #e8f4f8;
  overflow: hidden;
}
.map-canvas .water {
  position: absolute;
  background: #a8d8ea;
  border-radius: 40%;
  opacity: 0.6;
}
.map-canvas .park {
  position: absolute;
  background: #b8e0d2;
  border-radius: 30%;
  opacity: 0.5;
}
.map-canvas .road-h {
  position: absolute;
  height: .1875rem;
  background: #fff;
  opacity: 0.8;
}
.map-canvas .road-v {
  position: absolute;
  width: .1875rem;
  background: #fff;
  opacity: 0.8;
}
.map-marker {
  position: absolute;
  width: 1.75rem;
  height: 1.75rem;
  transform: translate(-50%, -100%);
  z-index: 10;
}
.map-marker .pin {
  width: 1.75rem;
  height: 1.75rem;
  background: #ee0a24;
  border-radius: 50% 50% 50% 0;
  transform: rotate(-45deg);
  box-shadow: 0 .125rem .375rem rgba(238,10,36,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
}
.map-marker .pin::after {
  content: '';
  width: .625rem;
  height: .625rem;
  background: #fff;
  border-radius: 50%;
}
.map-marker .label {
  position: absolute;
  bottom: -1.25rem;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0,0,0,0.7);
  color: #fff;
  font-size: .6875rem;
  padding: .125rem .5rem;
  border-radius: .25rem;
  white-space: nowrap;
  font-weight: 500;
}
.map-open-btn {
  position: absolute;
  bottom: .625rem;
  right: .625rem;
  background: #1989fa;
  color: #fff;
  border: none;
  border-radius: 1.25rem;
  padding: .375rem .875rem;
  font-size: .75rem;
  cursor: pointer;
}

/* 地理描述 */
.geo-section {
  background: #f7f8fa;
  border-radius: .625rem;
  padding: .875rem;
  margin-bottom: .625rem;
}
.geo-title {
  font-size: .8125rem;
  font-weight: bold;
  color: #646566;
  margin-bottom: .625rem;
}
.geo-text {
  font-size: .8125rem;
  color: #646566;
  line-height: 1.8;
  text-align: justify;
}
.geo-text p {
  margin: 0 0 .5rem 0;
  text-indent: 2em;
}
.geo-text p:last-child {
  margin-bottom: 0;
}

/* 底部关闭按钮 */
.dialog-footer {
  padding: 0 1rem 1rem;
}

.auto-scroll-p {
  max-height: 9rem;     /* 最大高度 */
  overflow-y: auto;      /* 内容多 → 自动出滚动条 */
  overflow-x: hidden;    /* 禁止横向滚动 */
  line-height: 1.6;
  padding: .5rem;
  border: .0625rem solid #eee;
  border-radius: .5rem;
}
</style>